/**
 * statut-badge.ts — libellé + variante du badge de statut d'un signalement/EDL.
 *
 * Règle métier (3.3) : un signalement RÉSOLU qui porte un suivi ultérieur
 * (« résolu mais à revoir » : devis en cours, point à surveiller…) s'affiche
 * distinctement — « Résolu · à revoir », en variante warning — pour qu'il ne se
 * confonde pas avec un résolu « propre ». Vaut pour les fiches incident ET les
 * états des lieux (même mécanique).
 */
import { SIGNALEMENT_STATUTS } from '@roronoa-collectivites/shared-types';
import type { Signalement, SignalementStatut } from '@roronoa-collectivites/shared-types';

const BASE_VARIANT: Record<SignalementStatut, 'info' | 'warning' | 'success' | 'neutral'> = {
  recu: 'info',
  planifie: 'info',
  en_cours: 'warning',
  resolu: 'success',
  archive: 'neutral',
};

export function statutBadge(
  s: Pick<Signalement, 'statut' | 'suiviUlterieur'>
): { label: string; variant: 'info' | 'warning' | 'success' | 'neutral' } {
  const base = SIGNALEMENT_STATUTS.find((x) => x.value === s.statut)?.label ?? s.statut;
  if (s.statut === 'resolu' && s.suiviUlterieur) {
    return { label: `${base} · à revoir`, variant: 'warning' };
  }
  return { label: base, variant: BASE_VARIANT[s.statut] };
}
